<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='formData' label-position="right" :label-width="200" :rules="ruleValidate"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="所属基地" prop="land_base_id">
              <Select v-model="formData.land_base_id" placeholder="请选择所属基地" class="perW30"
                      @on-change="selectBase">
                <Option v-for="(item,key) in landBaseList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="所属地块" prop="land_id">
              <Select v-model="formData.land_id" placeholder="请选择所属地块" class="perW30" @on-change="selectLand">
                <Option v-for="(item,key) in landInfoList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="加工批次" prop="plant_production_id">
              <Select v-model="formData.plant_production_id" placeholder="请选择加工批次" class="perW30">
                <Option v-for="(item,key) in plantProductionList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="销售单价" prop="sale_price">
              <InputNumber placeholder="请输入销售单价" class="perW20" v-model="formData.sale_price"></InputNumber>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="销售总量" prop="weight">
              <InputNumber placeholder="请输入销售总量" class="perW20" v-model="formData.weight"></InputNumber>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="销售类型" prop="type">
              <RadioGroup v-model="formData.type">
                <Radio :label="1">其他</Radio>
                <Radio :label="2">平台商家</Radio>
              </RadioGroup>
            </FormItem>
          </Col>

          <Col span="24" v-if="formData.type == 1">
            <FormItem label="商家名称" prop="shop_name">
              <Input placeholder="请输入商家名称" class="perW30" v-model="formData.shop_name"></Input>
            </FormItem>
          </Col>

          <Col span="24" v-if="formData.type == 2">
            <FormItem label="平台商家" prop="shop_id">
              <Select v-model="formData.shop_id" placeholder="请选择平台商家" class="perW30">
                <Option v-for="(item,key) in shopList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="销售单号" prop="order_sn">
              <Input placeholder="请输入销售单号" class="perW30" v-model="formData.order_sn"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="销售日期" prop="date">
              <DatePicker type="date" placeholder="请选择销售日期" class="perW30" v-model="formData.date"></DatePicker>
            </FormItem>
          </Col>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submit">提交</Button>
        </FormItem>

      </Form>
    </card>

  </div>
</template>
<script>
import {plantProductionSaleInfoApi, plantProductionSaleSaveApi} from '@/api/processing/processing/plantProductionSale'
import {landBaseAllApi} from '@/api/landBase/landBase'
import {landInfoAllApi} from '@/api/landBase/landInfo'
import {plantProductionAllApi} from "@/api/processing/processing/plantProduction";
import {shopAllApi} from "@/api/shop/shop";

export default {
  name: 'plantProductionSaleEdit',
  data() {
    return {
      formData: {
        id: 0,
        land_base_id: 0,
        land_id: 0,
        plant_production_id: 0,
        weight: 0,
        sale_price: 0,
        type: 1,
        shop_id: 0,
        shop_name: '',
        order_sn: '',
        date: '',
      },
      landBaseList: [],
      landInfoList: [],
      plantProductionList: [],
      shopList: [],
      ruleValidate: {
        land_base_id: [
          {required: true, message: '请选择所属基地', trigger: 'change'},
        ],
        land_id: [
          {required: true, message: '请选择所属地块', trigger: 'change'},
        ],
        plant_production_id: [
          {required: true, message: '请选择加工批次', trigger: 'change'},
        ],
        sale_price: [
          {required: true, type: 'number', min: 0.01, message: '请输入销售单价', trigger: 'blur'},
          {min: 0.01, max: 99999.99, type: 'number', message: '请输入0.01-99999.99的数字', trigger: 'blur'},
        ],
        weight: [
          {required: true, type: 'number', min: 0.01, message: '请输入销售总量', trigger: 'blur'},
          {min: 0.01, max: 99999999.99, type: 'number', message: '请输入0.01-99999999.99的数字', trigger: 'blur'},
        ],
        type: [
          {required: true, type: 'number', message: '请选择销售类型', trigger: 'change'},
        ],
        shop_id: [
          {required: false, message: '请选择商家', trigger: 'change'},
        ],
        shop_name: [
          {required: false, message: '请输入商家名称', trigger: 'blur'},
          {min: 2, max: 15, message: '请输入2-15位字符', trigger: 'blur'},
        ],
        order_sn: [
          {required: true, message: '请输入销售单号', trigger: 'blur'},
          {min: 2, max: 15, message: '请输入2-15位字符', trigger: 'blur'},
        ],
        date: [
          {required: true, type: 'date', message: '请选择销售日期', trigger: 'change'},
        ],
      },
    }
  },
  mounted() {

    this.loadLandBaseData()
    this.loadShopData()

    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {
    //提交数据
    submit() {

      // 其他
      if(this.formData.type == 1){
        this.formData.shop_id = 0
      }
      // 平台商家
      if(this.formData.type == 2){
        this.formData.shop_name = ''
      }

      // 验证数据
      this.$refs.formData.validate((valid) => {
        if (!valid) {
          this.$Message.error('请检查输入内容!')
          return false
        } else {
          //请求接口
          plantProductionSaleSaveApi(this.formData).then(res => {
            if (res.code === 200) {
              this.$Message.success('成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

    // 编辑加载数据
    loadFormData(id) {
      plantProductionSaleInfoApi(id).then(res => {
        //数据赋值
        this.formData = res.data

        // 字符串转换
        this.formData.land_base_id = this.formData.land_base_id.toString()
        this.formData.land_id = this.formData.land_id.toString()
        this.formData.plant_production_id = this.formData.plant_production_id.toString()
        this.formData.shop_id = this.formData.shop_id.toString()

        // 数字转换
        this.formData.sale_price = parseFloat(this.formData.sale_price)
        this.formData.weight = parseFloat(this.formData.weight)

        // 加载地块
        this.loadLandInfoData()
        // 加载加工批次
        this.loadPlantProductionData()

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 所有基地
    loadLandBaseData() {
      landBaseAllApi({type: 1}).then(res => {
        if (res.code === 200) {
          this.landBaseList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 选择基地
    selectBase() {
      // 加载地块
      this.formData.land_id = ''
      this.formData.plant_production_id = ''
      this.loadLandInfoData()
    },

    // 所有地块
    loadLandInfoData() {
      let landBaseId = this.formData.land_base_id
      if (!landBaseId) {
        return
      }
      landInfoAllApi({land_base_id: landBaseId}).then(res => {
        if (res.code === 200) {
          this.landInfoList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 选择地块
    selectLand() {
      // 加载加工批次
      this.formData.plant_production_id = ''
      this.loadPlantProductionData()
    },

    // 所有加工批次
    loadPlantProductionData() {
      let landId = this.formData.land_id
      if (!landId) {
        return
      }
      plantProductionAllApi({land_id: landId}).then(res => {
        if (res.code === 200) {
          this.plantProductionList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 所有店铺
    loadShopData() {
      shopAllApi().then(res => {
        if (res.code === 200) {
          this.shopList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },


  }
}
</script>
